import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=7918a03d&scoped=true"
import script from "./TableSettings.vue?vue&type=script&lang=js"
export * from "./TableSettings.vue?vue&type=script&lang=js"
import style0 from "./TableSettings.vue?vue&type=style&index=0&id=7918a03d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7918a03d",
  null
  
)

export default component.exports